module.exports = __webpack_public_path__ + "img/logos_customer_15.586d69ef.svg";